<template>
  <base-dialog
    class="option-linkage-dialog"
    show-close
    :visible.sync="visible"
    v-ps="'.el-dialog__body'"
  >
    <template v-slot:header>设置依赖</template>
    <div style="margin-bottom: 8px;margin-top: 10px;">
      选择父字段选项时,子字段只显示该父选项勾选的子字段选项
    </div>
    <div class="content" style="display: flex">
      <div class="left panel">
        <div class="head row">父字段</div>
        <div class="parent-row">
          <el-select v-model="linkage.cid" @change="clearLinkage">
            <el-option
              v-for="c in otherOptionControls"
              :key="c._cid"
              :value="c._cid"
              :label="c.name"
            ></el-option>
          </el-select>
        </div>
        <div class="option-container" v-ps>
          <div
            :class="['option', 'row', 'pointer', selectedIndex === idx ? 'selected' : '']"
            @click="changeOption(idx)"
            v-for="(o, idx) in parentOptions"
            :key="o.value"
          >
            {{ o.label }}
          </div>
        </div>
      </div>
      <div class="right panel">
        <div class="head row">子字段</div>
        <div class="row">
          {{ control.name }}
        </div>
        <div class="option-container" v-ps>
          <el-checkbox-group v-model="selectedOptions" @change="checkboxGroupChange">
            <el-checkbox
              class="option row"
              v-for="o in control.options"
              :key="o.value"
              :label="o.label"
            ></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <base-button type="primary" @click="visible = false">确 定</base-button>
    </span>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"

export default {
  name: "option-linkage-dialog",
  components: {
    BaseDialog,
    BaseButton
  },
  props: {
    control: Object,
    sheet: Object
  },
  computed: {
    otherOptionControls() {
      return (this.sheet?.controls || []).filter(
        c => c._type === "option" && c._cid !== this.control._cid && c.optionType !== "动态数据源"
      )
    },
    parentOptions() {
      return this.otherOptionControls.find(c => c._cid === this.linkage.cid)?.options || []
    }
  },
  data() {
    return {
      visible: false,
      linkage: {
        cid: null,
        map: null
      },
      selectedOptions: [],
      selectedIndex: 0
    }
  },
  methods: {
    open() {
      this.visible = true
      this.linkage = this.control.linkage
      this.changeOption(0)
    },
    changeOption(idx) {
      this.selectedIndex = idx
      let parentValue = this.parentOptions[idx]?.value
      this.selectedOptions = this.linkage.map?.[parentValue] || []
    },
    checkboxGroupChange() {
      let parentValue = this.parentOptions[this.selectedIndex].value
      if (!this.linkage.map) {
        this.linkage.map = {}
      }
      this.linkage.map[parentValue] = this.selectedOptions
    },
    clearLinkage() {
      this.linkage.map = {}
      this.changeOption(0)
    }
  }
}
</script>

<style lang="scss" scoped>
.option-linkage-dialog {
  ::v-deep .el-dialog__body {
    .el-select {
      .el-input__inner {
        border: none;
        height: 30px;
        padding-left: 0;
      }
    }
  }
  .content {
    color: #606266;
    margin-bottom: 10px;
    .panel {
      flex: 1;
      border: 2px solid #f5f5f5;
      .row {
        height: 30px;
        display: flex;
        align-items: center;
        border-bottom: 2px solid #f5f5f5;
        padding-left: 15px;
      }
      .head {
        font-weight: bold;
      }
      .parent-row {
        height: 30px;
        display: flex;
        align-items: center;
        border-bottom: 2px solid #f5f5f5;
        .el-select {
          ::v-deep .el-input__inner {
            padding-left: 15px;
          }
        }
      }
      .el-select {
        width: 100%;
      }
      .option-container {
        height: 200px;
        .option {
          border-bottom: none;
          margin: 0;
          &.selected {
            background: #eee;
          }
        }
        .el-checkbox-group {
          display: flex;
          flex-flow: column;
        }
      }
    }
    .left {
    }
    .right {
    }
  }
}
</style>
